












































































import { defineComponent } from '@vue/composition-api';
import { SdsIcon } from '@superbet-group/web.lib.ui-components';

export default defineComponent({
    props: {
        isUnlocked: {
            type: Boolean,
            required: true,
        },
        selections: {
            type: Number,
            required: true,
        },
        selectionsForFirstBonus: {
            type: Number,
            required: true,
        },
        selectionsNeededForNext: {
            type: Number,
            required: true,
        },
        nextPercentage: {
            type: Number,
            required: true,
        },
        percentage: {
            type: Number,
            required: true,
        },
        maximumPercentage: {
            type: Number,
            required: true,
        },
    },
    components: {
        SdsIcon,
    },
});
